export const container = {
  base: ['relative gap-2 w-full rounded-[8px] bg-[#F5F5F5]'].join(' '),
};

export const textarea = {
  base: [
    'px-4 bg-transparent border-none rounded-l-[0.5rem] text-[#101010] text-sm font-normal tracking-[-0.1px] overflow-hidden resize-none',
    'placeholder:text-[#BFBFBF] caret-[#3C78F4]',
    // 'focus-visible:outline-1 focus-visible:outline-offset-0 focus-visible:ring-offset-0 focus-visible:ring-1',
    'focus-visible:shadow-[0_0_0_1px_var(--border-border-black)] focus-visible:ring-0 focus-visible:ring-offset-0',
  ].join(' '),
  error: [
    'ring-1 ring-[#D15445] bg-[#FCEDEB]',
    'focus-visible:outline-[#D15445] focus-visible:ring-0',
  ].join(' '),
};

export const bottomArea = {
  base: ['relative mt-2 flex justify-between items-start gap-2 box-border text-xs font-normal'],
  error: ['text-[#D15445]'],
};

export const helperText = {
  base: ['flex-grow flex items-center gap-1'],
};

export const count = {
  base: ['flex-shrink-0'],
};
